export const ANIMATIONS = {
  animationTime:                        300,
};



export const CREATION_LOCK = {
  normalLock:                           10,
  lightLock:                            20,
  mediumLock:                           30,
  superLock:                            99,
  personalityLock:                      999,
  errorLock:                            2000,
};



export const HELPCOUNT_COMMON = {
  dateCount:                            10,
};



export const HELPCOUNT_ADDRESS = {
  zipCount:                             8,
  
  streetMinCount:                       8,
  streetMaxCount:                       256,

  numberMinCount:                       1,
  numberMaxCount:                       30,

  complementMinCount:                   8,
  complementMaxCount:                   256,

  districtMinCount:                     3,
  districtMaxCount:                     256,

  cityMinCount:                         3,
  cityMaxCount:                         256,

  stateMinCount:                        3,
  stateMaxCount:                        100,

  countryMinCount:                      3,
  countryMaxCount:                      100,
};



export const HELPCOUNT_FINCANCIAL = {
  agencyCount:                          8,
  accountCount:                         8,
  dvCount:                              1,
};



export const HELPCOUNT_PROFILE = {
  nameMinCount:                         10,
  nameMaxCount:                         200,

  cpfCount:                             11,

  cnpjCount:                            14,

  usernameMinCount:                     7,
  usernameMaxCount:                     50,

  birthdayCount:                        10,

  emailMinCount:                        11,
  emailMaxCount:                        60,

  passwordMinCount:                     8,
  passwordMaxCount:                     15,

  ddiMinCount:                          1,
  ddiMaxCount:                          4,

  phoneMinCount:                        10,
  phoneMaxCount:                        11,
  
  aboutMeCount:                         256,
  messageCount:                         500,
};



export const HELPCOUNT_RESERVE = {
  tableReserveCount:                    2,
  hourReserveCount:                     2,
};



export const TIMES = {
  mountTime:                            200,
  snackBarTime:                         1800,
};



const Values = {
  ...ANIMATIONS,
  ...CREATION_LOCK,
  ...HELPCOUNT_COMMON,
  ...HELPCOUNT_ADDRESS,
  ...HELPCOUNT_FINCANCIAL,
  ...HELPCOUNT_PROFILE,
  ...HELPCOUNT_RESERVE,
  ...TIMES,
};



export default Values;
